/** ElevenLabs voice presets — premium tutor voices for the sellable product tier. */
export const ELEVEN_VOICES: Record<
  string,
  { id: string; name: string; desc: string }
> = {
  rachel: {
    id: "21m00Tcm4TlvDq8ikWAM",
    name: "Rachel",
    desc: "Warm, calm — default Maya voice",
  },
  adam: {
    id: "pNInz6obpgDQGcFmaJgB",
    name: "Adam",
    desc: "Confident, clear American",
  },
  elif: {
    id: "Xb7hH8MSUJpSbSDYk0k2",
    name: "Alice",
    desc: "Articulate British English",
  },
};

export function resolveElevenVoiceId(preferred?: string): string {
  if (preferred && ELEVEN_VOICES[preferred]) return ELEVEN_VOICES[preferred].id;
  return (
    (import.meta.env.VITE_ELEVEN_VOICE as string | undefined) ||
    ELEVEN_VOICES.rachel.id
  );
}

/** `elevenlabs` = premium default; `sesame` = self-hosted open-source path. */
export type VoiceTtsMode = "elevenlabs" | "sesame" | "auto";

export function voiceTtsMode(): VoiceTtsMode {
  const m = (import.meta.env.VITE_VOICE_TTS as string | undefined)?.toLowerCase();
  if (m === "sesame" || m === "elevenlabs" || m === "auto") return m;
  return "elevenlabs";
}
